/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {
  useLayoutEffect,
  useRef,
  useState,
  type ReactNode,
} from "react";
import fitty from "fitty";
import clsx, { type ClassValue } from "clsx";

export default function FitWidthText({
  children,
  getfontSize,
  className,
}: {
  children?: ReactNode;
  className?: ClassValue[] | ClassValue;
  getfontSize?: (fontSize: string | number) => void;
}) {
  const childrenArray = React.Children.toArray(children);
  const firstLineRef = useRef<HTMLHeadingElement>(null);
  const [fontSize, setFontSize] = useState<string | number>("auto");
  useLayoutEffect(() => {
    if (!firstLineRef.current) return;
    const instance = fitty(firstLineRef.current, {
      minSize: 16,
      maxSize: 1000,
    });
    const handleFit = (e: any) => {
      setFontSize(e.detail.newValue);
      getfontSize?.(e.detail.newValue);
    };
    const el = firstLineRef.current;
    el.addEventListener("fit", handleFit);
    instance.fit();
    const timer = setTimeout(() => {
      instance.fit();
    }, 100);
    return () => {
      clearTimeout(timer);
      el.removeEventListener("fit", handleFit);
      instance.unsubscribe();
    };
  }, [getfontSize]);

  return (
    <div
      className={clsx(
        "w-full flex h-auto flex-col justify-center items-center font-bold font-inter leading-[0.82] text-[#d1d1d1] overflow-hidden",
        className,
      )}
    >
      <h1
        ref={firstLineRef}
        className="inline-block tracking-tight whitespace-nowrap  text-center uppercase"
      >
        {childrenArray?.[0] || "EXPERT DIGITAL"}
      </h1>
      {childrenArray?.slice(1).map((child, index) => (
        <h1
          key={index}
          style={{ fontSize: fontSize }}
          className="inline-block tracking-tight whitespace-nowrap  text-center uppercase"
        >
          {child}
        </h1>
      ))}
    </div>
  );
}
